import { Component, ViewEncapsulation } from '@angular/core';
import { entAnimations } from 'src/app/animations';
import { UserInfo } from 'src/app/models/user-info.model';
import { UsersService } from 'src/app/services/users/users.service';

@Component({
  selector: 'app-error-maintenance',
  templateUrl: './error-maintenance.component.html',
  styleUrls: ['./error-maintenance.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class ErrorMaintenanceComponent {
  user: UserInfo;

  constructor(private _userService: UsersService) {
    this.user = this._userService.currentUserValue;
  }
}
